import { PlanCode, PlanStripeLookupKey } from "@/types/subscription";

// 定义套餐级别顺序（数字越大级别越高）
export const planLevels = {
  [PlanCode.TRIAL]: 0,
  [PlanCode.EXPLORER]: 1,
  [PlanCode.VISIONARY]: 2,
  [PlanCode.PRIME]: 3,
};

// 获取下一个可升级的套餐作为默认选择
export function getNextUpgradePlan(currentPlanCode: PlanCode | undefined): PlanCode {
  if (!currentPlanCode) return PlanCode.EXPLORER;
  switch (currentPlanCode) {
    case PlanCode.TRIAL:
      return PlanCode.EXPLORER;
    case PlanCode.EXPLORER:
      return PlanCode.VISIONARY;
    case PlanCode.VISIONARY:
      return PlanCode.PRIME;
    case PlanCode.PRIME:
      return PlanCode.PRIME; // 已经是最高级别
    default:
      return PlanCode.VISIONARY;
  }
}

// 检查是否为降级（不允许降级）
export function isPlanDowngrade(currentPlanCode: PlanCode | undefined, targetPlan: PlanCode): boolean {
  if (!currentPlanCode || !(currentPlanCode in planLevels)) return false;
  return planLevels[targetPlan] < planLevels[currentPlanCode as PlanCode];
}

// 映射 PlanCode 到 PlanStripeLookupKey
export function mapPlanCodeToStripeLookupKey(planCode: PlanCode): PlanStripeLookupKey {
  switch (planCode) {
    case PlanCode.EXPLORER:
      return PlanStripeLookupKey.MONTH;
    case PlanCode.VISIONARY:
      return PlanStripeLookupKey.YEAR;
    case PlanCode.PRIME:
      return PlanStripeLookupKey.LIFETIME;
    default:
      return PlanStripeLookupKey.MONTH;
  }
};
